import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  FetchJobUseCaseInput,
  FetchJobUseCaseOutput,
  IAppErrorFactory,
  IFetchJobUseCase,
  IJobsService,
} from '../../types'

@injectable()
export default class FetchJobInteractor implements IFetchJobUseCase {
  @inject(symbols.IJobsService) private jobsService: IJobsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchJobUseCaseInput): Promise<FetchJobUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const job = await this.jobsService.fetchJob(input)

      output.job = job
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchJobUseCaseOutput {
    return {
      job: null,
      error: null,
    }
  }
}
